module.exports = __webpack_public_path__ + "static/img/platnew.8d1f3a2b.png";